import {Component, inject, signal} from '@angular/core';
import {MaterialModule} from '../../../../core/modules/material.module';
import {SharedModule} from '../../../../core/modules/shared.module';
import {PagesContainerComponent} from '../../pages-container/pages-container.component';
import {ForumTalkService} from '../../../../core/services/forumTalk.service';
import {NgxChartsModule} from '@swimlane/ngx-charts';

const CHART_FIELDS: { key: string; label: string }[] = [
  { key: 'active_admins',     label: 'statistics.activeAdminProfiles',  },
  { key: 'active_users',      label: 'statistics.activeUserProfiles' },
  { key: 'total_msgs',        label: 'statistics.totalMsgs' },
  { key: 'total_files',       label: 'statistics.totalFiles' },
];

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss'],
  standalone: true,
  imports: [MaterialModule, SharedModule, PagesContainerComponent, NgxChartsModule],
})

export class StatisticsComponent {
  private forumTalkService = inject(ForumTalkService);

  statistics = signal<any>(null);
  chartData = signal<any[]>([]);
  colorScheme = 'cool';


  ngOnInit() {
    this.forumTalkService.getStatistics().subscribe((data: any[]) => {
      if (data.length > 0) {
        data.reverse();
        let lastData = [...data].reverse()[0];
        this.statistics.set(lastData);
        this.chartData.set(this.buildChartData(data));
        console.log(this.chartData());
      }
    });
  }

  private formatDate(iso: string): string {
    const d = new Date(iso);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yy = String(d.getFullYear()).slice(-2);
    return `${dd}.${mm}.${yy}`;
  }

  private buildChartData(data: any[]): any[] {
    return CHART_FIELDS.map(field => ({
      name: field.label,
      series: data.map(item => ({
        name: this.formatDate(item.createdAt),
        value: item[field.key] ?? 0,
      })),
    }));
  }
}
